import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchBaselineTasks: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_BASELINE_TASK_REQUEST,
                        types.SEARCH_BASELINE_TASK_SUCCESS,
                        types.SEARCH_BASELINE_TASK_FAILURE
                    ]
                }
            });
        },
    searchForGanttTasks: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/search-gantt',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_BASELINE_TASK_GANTT_REQUEST,
                        types.SEARCH_BASELINE_TASK_GANTT_SUCCESS,
                        types.SEARCH_BASELINE_TASK_GANTT_FAILURE
                    ]
                }
            });
        },        
    saveBaselineTask: (baselineTask) =>
        (dispatch) => {
            if (baselineTask.id === 0) {
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'baselinetask/create',
                        method: 'POST',
                        body: baselineTask,
                        types: [
                            types.CREATE_BASELINE_TASK_REQUEST,
                            types.CREATE_BASELINE_TASK_SUCCESS,
                            types.CREATE_BASELINE_TASK_FAILURE
                        ]
                    }
                });
            } else {
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'baselinetask/update',
                        method: 'PUT',
                        body: baselineTask,
                        types: [
                            types.UPDATE_BASELINE_TASK_REQUEST,
                            types.UPDATE_BASELINE_TASK_SUCCESS,
                            types.UPDATE_BASELINE_TASK_FAILURE
                        ]
                    }
                });
            }

        },
    activeToggle: (baselineTaskIds, isActive, isLocationTaskListActive) =>
        (dispatch) => {
            const req = {
                baselineTaskIds,
                isActive,
                isLocationTaskListActive
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/active-toggle',
                    method: 'PUT',
                    body: req,
                    types: [
                        types.TOGGLE_ACTIVE_TASK_REQUEST,
                        types.TOGGLE_ACTIVE_TASK_SUCCESS,
                        types.TOGGLE_ACTIVE_TASK_FAILURE
                    ]
                }
            });
        },
    loadBaselineTaskListFilters: (subscriptionId, baselineId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subscriptionId,
                baselineId: baselineId
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/list-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_BASELINE_TASK_LIST_FILTERS_REQUEST,
                        types.LOAD_BASELINE_TASK_LIST_FILTERS_SUCCESS,
                        types.LOAD_BASELINE_TASK_LIST_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadBaselineTaskFormFilters: (subscriptionId, baselineId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subscriptionId,
                baselineId: baselineId
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/form-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_BASELINE_TASK_FORM_FILTERS_REQUEST,
                        types.LOAD_BASELINE_TASK_FORM_FILTERS_SUCCESS,
                        types.LOAD_BASELINE_TASK_FORM_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadBaselineTask: (id) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/' + id,
                    method: 'GET',
                    types: [
                        types.LOAD_BASELINE_TASK_REQUEST,
                        types.LOAD_BASELINE_TASK_SUCCESS,
                        types.LOAD_BASELINE_TASK_FAILURE
                    ]
                }
            });
        },
    optionSearch: (searchTerm, baselineId, baselineTaskId, isPrereqQuery) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/option-search',
                    method: 'POST',
                    body: {
                        searchTerm,
                        baselineId,
                        baselineTaskId,
                        isPrereqQuery
                    },
                    types: [
                        types.OPTION_SEARCH_BASELINE_TASK_REQUEST,
                        types.OPTION_SEARCH_BASELINE_TASK_SUCCESS,
                        types.OPTION_SEARCH_BASELINE_TASK_FAILURE
                    ]
                }
            });
        },
    loadBulkPushdownFilters: (baselineId) => {
        return (dispatch) => {
            const body = {
                baselineId: baselineId
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/bulk-pushdown-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_BULK_PUSHDOWN_FILTERS_REQUEST,
                        types.LOAD_BULK_PUSHDOWN_FILTERS_SUCCESS,
                        types.LOAD_BULK_PUSHDOWN_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    bulkPushdown: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/bulk-pushdown',
                    method: 'POST',
                    body: request,
                    types: [
                        types.PERFORM_BULK_PUSHDOWN_REQUEST,
                        types.PERFORM_BULK_PUSHDOWN_SUCCESS,
                        types.PERFORM_BULK_PUSHDOWN_FAILURE
                    ]
                }
            });
        }
    },

    loadBulkLocationAttribFilters: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/bulk-location-attrib-filters',
                    method: 'POST',
                    types: [
                        types.LOAD_BULK_LOCATION_ATTRIB_FILTERS_REQUEST,
                        types.LOAD_BULK_LOCATION_ATTRIB_FILTERS_SUCCESS,
                        types.LOAD_BULK_LOCATION_ATTRIB_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    bulkLocationPushdownSearch: (params) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/bulk-location-pushdown-search',
                    method: 'POST',
                    body: params,
                    types: [
                        types.SEARCH_BULK_LOCATION_PUSHDOWN_REQUEST,
                        types.SEARCH_BULK_LOCATION_PUSHDOWN_SUCCESS,
                        types.SEARCH_BULK_LOCATION_PUSHDOWN_FAILURE
                    ]
                }
            });
        }
    },
    bulkLocationPushdownSearchNoProject: (params) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/bulk-location-pushdown-search-no-project',
                    method: 'POST',
                    body: params,
                    types: [
                        types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_REQUEST,
                        types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_SUCCESS,
                        types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_FAILURE
                    ]
                }
            });
        }
    },    
    searchCrossBaseline: (params) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/search-cross-baseline',
                    method: 'POST',
                    body: params,
                    types: [
                        types.SEARCH_CROSS_BASELINE_REQUEST,
                        types.SEARCH_CROSS_BASELINE_SUCCESS,
                        types.SEARCH_CROSS_BASELINE_FAILURE
                    ]
                }
            });
        }
    },
    searchCrossBaselineLink: (params) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/search-cross-baseline-link',
                    method: 'POST',
                    body: params,
                    types: [
                        types.SEARCH_CROSS_BASELINE_LINK_REQUEST,
                        types.SEARCH_CROSS_BASELINE_LINK_SUCCESS,
                        types.SEARCH_CROSS_BASELINE_LINK_FAILURE
                    ]
                }
            });
        }
    },
    updateCrossBaselineLinkCount: (params) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/update-cross-baseline-link-count',
                    method: 'POST',
                    body: params,
                    types: [
                        types.SEARCH_CROSS_BASELINE_LINK_COUNT_REQUEST,
                        types.SEARCH_CROSS_BASELINE_LINK_COUNT_SUCCESS,
                        types.SEARCH_CROSS_BASELINE_LINK_COUNT_FAILURE
                    ]
                }
            });
        }
    },
    updateCrossBaselineLink: (params) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/update-cross-baseline-link',
                    method: 'PUT',
                    body: params,
                    types: [
                        types.UPDATE_CROSS_BASELINE_LINK_REQUEST,
                        types.UPDATE_CROSS_BASELINE_LINK_SUCCESS,
                        types.UPDATE_CROSS_BASELINE_LINK_FAILURE
                    ]
                }
            });
        }
    },
    loadCrossBaselineFormFilters: (subscriptionId, baselineId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subscriptionId,
                baselineId: baselineId
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/cross-baseline-form-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_CROSS_BASELINE_FORM_FILTERS_REQUEST,
                        types.LOAD_CROSS_BASELINE_FORM_FILTERS_SUCCESS,
                        types.LOAD_CROSS_BASELINE_FORM_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadOrderTasksFilters: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/order-tasks-filters',
                    method: 'POST',
                    body: request,
                    types: [
                        types.LOAD_ORDER_BASELINE_TASKS_FILTERS_REQUEST,
                        types.LOAD_ORDER_BASELINE_TASKS_FILTERS_SUCCESS,
                        types.LOAD_ORDER_BASELINE_TASKS_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    orderBaselineTasks: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/order-tasks',
                    method: 'POST',
                    body: request,
                    types: [
                        types.ORDER_BASELINE_TASKS_REQUEST,
                        types.ORDER_BASELINE_TASKS_SUCCESS,
                        types.ORDER_BASELINE_TASKS_FAILURE
                    ]
                }
            });
        }
    },
    updateDates: (taskId, startDate, targetDate, fakeOpeningDate) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/update-dates',
                    method: 'POST',
                    body: { 
                        taskId: taskId, 
                        startDate: startDate, 
                        targetDate: targetDate, 
                        fakeOpeningDate: fakeOpeningDate 
                    },
                    types: [
                        types.UPDATE_BASELINE_TASKS_DATES_REQUEST,
                        types.UPDATE_BASELINE_TASKS_DATES_SUCCESS,
                        types.UPDATE_BASELINE_TASKS_DATES_FAILURE
                    ]
                }
            });
        }
    },
    updateContingent: (taskId, contingentId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/update-contingent',
                    method: 'POST',
                    body: {
                        taskId: taskId,
                        contingentId: contingentId
                    },
                    types: [
                        types.UPDATE_BASELINE_TASK_CONTINGENT_REQUEST,
                        types.UPDATE_BASELINE_TASK_CONTINGENT_SUCCESS,
                        types.UPDATE_BASELINE_TASK_CONTINGENT_FAILURE
                    ]
                }
            });
        }
    },
    bulkUpdateAttributes: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/bulk-update-attrib',
                    method: 'POST',
                    body: request,
                    types: [
                        types.PERFORM_BULK_UPDATE_ATTRIB_REQUEST,
                        types.PERFORM_BULK_UPDATE_ATTRIB_SUCCESS,
                        types.PERFORM_BULK_UPDATE_ATTRIB_FAILURE
                    ]
                }
            });
        }
    },
    loadBulkUpdateAttributeFilters: (baselineId) => {
        return (dispatch) => {
            const body = {
                baselineId: baselineId
            };
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baselinetask/bulk-update-attribute-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_REQUEST,
                        types.LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_SUCCESS,
                        types.LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    updateCrossBaselineTasks: (tasks) =>
        (dispatch) => {
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'baselinetask/cross-bulk-update-attrib',
                        method: 'POST',
                        body: tasks,
                        types: [
                            types.UPDATE_BASELINE_TASK_REQUEST,
                            types.UPDATE_BASELINE_TASK_SUCCESS,
                            types.UPDATE_BASELINE_TASK_FAILURE
                        ]
                    }
                });           

        }
}
